export default __webpack_public_path__ + "static/media/infoSVG.d0d21e86.svg";